module.exports = __webpack_public_path__ + "media/images/home/flow_r_2-b6487252521f404b299f6ebe0c96446e.svg";